<template>
  <nuxt-link class="tw-page-logo" to="/" :title="$t('header.go_to_startpage')" :aria-label="$t('header.go_to_startpage')">
    <tw-icon-logo variant="blue" :with-claim="true" class="tw-page-logo-img tw-page-logo-img--desktop" :width="300" :height="37" />
  </nuxt-link>
</template>

<style lang="scss" scoped>
.tw-page-logo {
  padding: 0.25rem;

  &-img {
    width: 300px;
    display: inline-block;
  }
}
</style>
